import '@webcomponents/custom-elements';
import 'custom-event-polyfill';
import 'formdata-polyfill';
import 'ie-array-find-polyfill';
import 'intersection-observer';
import 'objectFitPolyfill';
import 'picturefill';
import 'picturefill/dist/plugins/typesupport/pf.type';
import 'polyfill-array-includes';
import 'promise-polyfill/src/polyfill';
import 'url-polyfill';
import 'whatwg-fetch';
import arrayFrom from 'array-from';
import elementClosest from 'element-closest';
import svg4everybody from 'svg4everybody';

if (!Array.from) {
	Array.from = arrayFrom;
}

elementClosest(window);

svg4everybody();
